<script>
  import { media } from "svelte-match-media";
  import Actions from "@components/Actions";
  import Button from "@components/Button";
  import GivenQuestions from "@components/features/GivenQuestions";
  import { openPaymentForm, openPaywall } from "@components/features/Paywall";
  import TextButton from "@components/TextButton";
  import { _ } from "@services/i18n";
  import {
    allowedQuestions,
    allowedQuestionsOnScreen,
    displayAllowedQuestions,
    resetAllowedQuestions
  } from "@stores/features/allowed-questions";
  import { userHasPaid } from "@stores/features/paywall";

  $: shouldShow = $allowedQuestionsOnScreen &&
                  !$userHasPaid;

  /**
   * Close allowed questions sheet and show paywall
   * in payment/login state
   */
  function buy() {
    resetAllowedQuestions();
    openPaymentForm();
  }

  /**
   * Close allowed questions sheet and show paywall
   * in default state
   */
   function close() {
    resetAllowedQuestions();
    openPaywall();
  }
</script>

{#if shouldShow}
  <GivenQuestions
    on:error={() => displayAllowedQuestions.set(true)}
    on:question-asked={() => displayAllowedQuestions.set(false)}
    questions={$allowedQuestions}
    title={
      $_("components.allowed_questions.title", {
        default: "Choose one of these…"
      })
    }
  >

  <div slot="actions">
    <Actions>
      {#if $media.mobile}
        <TextButton bold={true} on:click={buy}>
          {
            $_("components.allowed_questions.left_action_button.text", {
              default: "Buy Pass"
            })
          }
        </TextButton>
      {:else}
        <Button on:click={buy}>
          {
            $_("components.allowed_questions.left_action_button.text", {
              default: "Buy Pass"
            })
          }
        </Button>
      {/if}
      <TextButton bold={true} on:click={close}>
        {
          $_("components.allowed_questions.right_action_button.text", {
            default: "Restart"
          })
        }
      </TextButton>
    </Actions>
  </div>
  </GivenQuestions>
{/if}
